export const parseFinYearLabels = (
  finYear: string // e.g. "2024"
): { yr1Label: string; yr2Label: string } => {

  // console.log(finYear, "finYear on fun");

  if (!finYear) {
    return { yr1Label: "", yr2Label: "" };
  }

  const startYear = parseInt(finYear, 10); // 2024

  // CY: 2024-25
  const yr2Label = `${startYear}-${String((startYear + 1) % 100).padStart(2, "0")}`;

  // LY: 2023-24
  const yr1Label = `${startYear - 1}-${String(startYear % 100).padStart(2, "0")}`;

  return { yr1Label, yr2Label };
};


